import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
  MAT_DIALOG_DATA, 
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose
} from '@angular/material/dialog';
import { DialogData } from '../purchaseorder-delete-modal/purchaseorder-delete-modal.component';
import {MatButtonModule} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { CommonModule, Location } from '@angular/common';
import { StoresService } from 'src/app/home/services/stores.service';
import { ImplantsEditComponent } from '../implants-edit/implants-edit.component';
import { Router, RouterLink } from '@angular/router';
import { ToastMessageComponent } from "../../common/toast-message/toast-message.component";
import { PaginationComponent } from "../../home/common/pagination/pagination.component";

@Component({
  selector: 'app-impants-low-stock-modal',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    CommonModule,
    RouterLink,
    ToastMessageComponent,
    PaginationComponent
],
  templateUrl: './impants-low-stock-modal.component.html',
  styleUrl: './impants-low-stock-modal.component.scss'
})
export class ImpantsLowStockModalComponent {
 @ViewChild('timelineWrapper', { static: true }) timelineWrapper: ElementRef;

  ngAfterViewInit() {
    const timelines = this.timelineWrapper.nativeElement.querySelectorAll('.timeline');
        
    timelines.forEach(timeline => {
      const dot: any = timeline.querySelector('.timeline-dot');
      const content: any = timeline.querySelector('.timeline-content');
      const contentHeight = content.offsetHeight;
      const dotTop = contentHeight / 2;
      const dotsTop = contentHeight * 1.075;
      dot.style.top = `${dotTop}px`;
    
      const line: any = timeline.querySelector('.timeline-line');
      
      if (line) {
        line.style.height = `${dotsTop}px`;
      }
    });
  }
  public dialogData: any;

  public lowStockList: any;

  constructor(
    public storeService: StoresService,
    public dialogRef: MatDialogRef<ImpantsLowStockModalComponent>,
    public dialog: MatDialog,
    public location: Location,
    public router: Router,

    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    if(data){
      this.dialogData = data;
    }
  }

  ngOnInit(): void {
    this.getImplantDetails();
  }

  getImplantDetails(){
    console.log(this.dialogData);
    this.storeService.getLowStockProductDetails(this.dialogData.storeId, this.dialogData.productId).subscribe((res)=>{
      if (res.data) {
        this.lowStockList = res.data;
        console.log('Low stock product details:', this.lowStockList);
        if (this.lowStockList && this.lowStockList.length > 0) {
          console.log('Sample low stock product:', this.lowStockList[0]);
        }
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
